import React, {Component} from 'react'
import TableList from "./Table";
import {Paper} from "@material-ui/core";
import {ListProvider} from "../../../../ContextComponents/ListContext";
import Charts from "../Charts";
import ListDesignerHoc from "../../../../HocHelpers/ListDesignerHoc";

class List extends Component {
    constructor(props) {
        super(props);
        this.inteval = 0;
        this.state = {
            data: {
                content: [],
                totalElements: 0
            },
            listName: '',
            filterOptions: false,
            advancedFilter: [],
            columns: [],
            rowsPerPage: 25,
            rowsPerPageOptions: [5, 10, 25, 50, 100],
            page: 0,
            selectedRows: [],
            searchValue: '',
            loading: false,
            isCompact: true,
            label: '',
            hideListHeader: true,
            hideListFooter: true,
            hideQuickSearch: true,
            hideAdvancedSearch: true,
            hideColumnHeader: true,
            hideLabel: false,
            exportable: false,
            selectable: true,
            sortable: true,
            showCountSelected: true,
            sumSelectedFields: true,
            layoutType: 'auto'
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            data,
            data: {source = {}, gridProps = {}},
            listData,
            pivotData,
            pivotGeneratedColumns
        } = this.props;


        if (listData && listData !== prevProps.listData) {
            this.setState({
                data: listData,
                pivotData: pivotData,
                pivotColumns: pivotGeneratedColumns
            })
        }


        if (data !== prevProps.data) {
            this.setState({
                label: data.name,
                columns: data.columns,
                pivotColumns: pivotGeneratedColumns,
                filterFields: data.filterFields,
                sort: data.sort,
                paged: source.paged,
                refreshTime: data.refreshTime,
                hideListHeader: gridProps.hideListHeader,
                hideListFooter: gridProps.hideListFooter,
                hideColumnHeader: gridProps.hideColumnHeader,
                hideQuickSearch: gridProps.hideQuickSearch,
                hideAdvancedSearch: gridProps.hideAdvancedSearch,
                hideLabel: gridProps.hideLabel,
                selectable: gridProps.selectable,
                sortable: gridProps.sortable,
                exportable: gridProps.exportable,
                showCountSelected: gridProps.showCountSelected,
                sumSelectedFields: gridProps.sumSelectedFields,
                layoutType: gridProps.layoutType,
                presentation: data.presentation,
                rowsPerPage: 25,
            })
        }

    }


    render() {
        const {list = {}, data} = this.props;
        const {pivotData, pivotColumns} = this.state;
        const styles = list.styles ? list.styles[0] : {};
        return (
            <>
                <Paper style={{
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    minHeight: styles.minHeight,
                    borderTop: `${styles.borderTop}px solid`,
                    borderRight: `${styles.borderRight}px solid`,
                    borderBottom: `${styles.borderBottom}px solid`,
                    borderLeft: `${styles.borderLeft}px solid`,
                    borderColor: styles.borderColor,
                    width: styles.width,
                    margin: styles.margin,
                    padding: styles.padding,
                    shadowColor: styles.shadowColor,
                    boxShadow: `${styles.shadowBoxVertical || '0'}px ${styles.shadowBoxHorizontal || '0'}px ${styles.shadowBoxBlur || '0'}px ${styles.shadowBoxSpread || '0'}px ${styles.shadowColor || ''}`,
                }}>
                    <ListProvider value={{
                        ...this.state,
                        listSchema: this.props.list,
                        listRecord: data,
                        loadSampleData: this.props.loadSampleData,
                        loadedSampleData: this.props.loadedSampleData,
                    }}>
                        {data.presentation === 'grid' || data.presentation === undefined ? (
                            <TableList/>
                        ) : (
                            <Charts
                                 pivotColumns={pivotColumns}
                                 pivotData={pivotData}
                                 sort={this.state.sort}
                                 paged={this.state.paged}
                            />
                        )}
                    </ListProvider>
                </Paper>
            </>
        );
    }
}

export default ListDesignerHoc(List);
